<div class="app-container" [class.show-spinner]="showLoadingSpinner()">
  @if (headerItems && !isUnauthorizedRoute()) {
    <lib-header
      [adminUrl]="adminUrl"
      [headerItems]="headerItems"
      [isProvider]="true"
      [isAdmin]="true"
      [unreadMessageCount]="unreadMessageCount"
      (entraLogout)="systemService.logout()"
      (handleTaskSelected)="(null)">
    </lib-header>
  }
  @if (!isUnauthorizedRoute()) {
    <lib-subheader class="admin-subheader" [topMenu]="menu"></lib-subheader>
  }
  <div class="body">
    @if (!isUnauthorizedRoute()) {
      <div class="breadcrumb-appcomponent-container">
        <lib-breadcrumbs></lib-breadcrumbs>
      </div>
    }
    <router-outlet />
  </div>
  <div class="footer">
    <lib-footer></lib-footer>
  </div>
  @if (sideDrawerService.config$ | async) {
    <lib-side-drawer></lib-side-drawer>
  }
</div>
